<template>
  <!-- 展览 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :inline="true" :model="form" ref="form"  >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="展览名称：" prop="name">
              <el-input  @keyup.enter.native='getTableList' v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="展览类型：" prop="type">
              <el-select clearable   @keyup.enter.native='getTableList' v-model="form.type" placeholder="请选择类型">
                <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加展览
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" >
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="展览名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="address" label="展览地点"></el-table-column>
          <el-table-column prop="time" label="展览时间">
            <template slot-scope="scope">
              <span
                v-if="scope.row.type == 1">{{scope.row.beginTime}}~{{scope.row.endTime}}</span>
              <span v-else>{{scope.row.time}}</span>

            </template>
          </el-table-column>

          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">{{ filterData(scope.row.type, typeList)  }}</template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog title="展览管理" :close-on-click-modal="false"
        @close="onCancel" :visible.sync="dialogVisible" :width="'65%'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item class="mb-30" prop="name">
                <el-input :disabled="operation == 'view'" v-model="addForm.name" placeholder="请输入展览名称" />
              </el-form-item>

              <el-form-item class="mb-30" prop="type">
                <el-select v-model="addForm.type" @change="selectExhibitonType" :disabled="operation == 'view'"
                  placeholder="请选择展览类型">
                  <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName"
                    :value="item.dictCode">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-if="exhibitonType == 1" class="mb-30" prop="timeArr">
                <el-date-picker v-model="timeArr" :disabled="operation == 'view'" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" @change="timeChange" type="daterange" range-separator="至"
                  start-placeholder="开展时间" end-placeholder="闭展时间">
                </el-date-picker>
              </el-form-item>

              <el-form-item class="mb-30" prop="address">
                <el-input v-model="addForm.address" :disabled="operation == 'view'" placeholder="请输入展览地点" />
              </el-form-item>

              <el-form-item class="mb-30" prop="szzturl">
                <el-input v-model="addForm.szzturl" :disabled="operation == 'view'" placeholder="请输入url" />
              </el-form-item>

              <el-form-item class="mb-30" prop="time" v-if="exhibitonType != 1">
                <el-date-picker v-model="addForm.time" :disabled="operation == 'view'" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" type="date" placeholder="请选择展览时间"></el-date-picker>
              </el-form-item>

              <el-form-item class="mb-30" prop="des">
                <cmp-ckeditor ref="myCkeditor" :readOnly="operation == 'view'" :defaultMsg="addForm.des" :id="`ue1`"
                  :height="150"></cmp-ckeditor>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item class="avatar-uploader-form" required>
                <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'"
                  accept="image/*" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="imgUrl" style="width: 100%;height: 100%;object-fit:contain;" :src="imgUrl" class="avatar">
                  <div v-else>
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__text">上传展览封面</div>
                  </div>
                </el-upload>

                <div class="tip-img">建议图片大小：1600 * 900</div>
              </el-form-item>

              <!-- <el-form-item class="avatar-uploader-form mt-40" required>
                <el-upload :file-list="fileList" action="/singleMuseum/attach/upload" list-type="picture-card"
                  :disabled="operation == 'view'" accept="image/*" :data="configData" :on-remove="handleUnitPicRemove"
                  :on-success="handleUnitPicSuccess" :before-upload="beforeUnitPicUpload">
                  <div class="img-uploader">
                    <i class="el-icon-plus"></i>
                    <span>上传展览图片</span>
                  </div>
                </el-upload>
              </el-form-item> -->
            </el-col>
          </el-row>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation !== 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" :loading="loadingSave" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

        <!-- 剪裁组件弹窗 -->
        <cropper-image ref="cropperRef" @uploadImgSuccess="handleAvatarSuccess">
    </cropper-image>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import cmpCkeditor from '@cmp/editor/ckeditor'
import CropperImage from "@cmp/cropper";

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  components: { cmpCkeditor, CropperImage },
  data() {
    const validateTime = (rule, value, callback) => {
      if (this.timeArr && this.timeArr.length <= 0 || !this.timeArr) {
        callback(new Error('展览时间不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        name: '',
        type: '',
      },
      fileList: [],
      typeList: [{dictCode: '0', dictName: 'Permanent Exhibitions' },{dictCode: '1', dictName: 'Special Exhibitions' }],
      operation: 'add',
      addForm: {},
      rules: {
        name: [{ required: true, message: '展览名称不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '展览类型不能为空', trigger: 'blur' }],
        timeArr: [{ required: true, validator: validateTime, trigger: 'blur' }],
      },
      configData: {
        tableName: 'collect'
      },
      loadingSave: false,
      imgUrl: "",
      timeArr: [],
      pics: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      exhibitonType: '',
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$http.get('bs/enExhibition/list',{
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    timeChange(arr) {
      if (!arr) {
        this.addForm.beginTime = ""
        this.addForm.endTime = ""
      } else {
        this.addForm.beginTime = arr[0]
        this.addForm.endTime = arr[1]
      }
    },

    selectExhibitonType(type) {
      this.exhibitonType = type
    },


    filterData(dictcode, list) {
      let arr = list.filter(item => {
        return item.dictCode == dictcode
      })
      if (arr && arr.length > 0) {
        return arr[0].dictName
      }

      return null
    },

    // 重置查询
    resetForm() {
      this.form = {
        name: '',
        type: '',
        status: ''
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.timeArr = []
      this.operation = "view"
      this.exhibitonType = obj.type
      this.$api.applet.getEnExhibitionDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result

            if (this.exhibitonType == '1') {
              if (res.result.beginTime) {
                this.timeArr.push(res.result.beginTime)
              } if (res.result.endTime) {
                this.timeArr.push(res.result.endTime)
              }
            }
            if (res.result.mainPic) {
              this.imgUrl = res.result.mainPic
            }

            if (res.result.pics) {
              let fileList = res.result.pics.split(';')
              fileList.map(item => {
                if (item) {
                  if (item.indexOf('http') != -1) {
                    this.fileList.push({
                      url: item
                    })
                  } else {
                    this.fileList.push({
                      url: `/singleMuseum/attach/getFile?fileId=${item}`
                    })
                  }
                }
              })
            }

          }
        }
      })
    },

    // 新增
    handleAdd() {
      this.operation = "add"

      this.exhibitonType = '0'
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      this.timeArr = []
      this.exhibitonType = obj.type
      if (this.exhibitonType == '1' || this.exhibitonType == '3') {
        if (obj.beginTime) {
          this.timeArr.push(obj.beginTime)
        }

        if (obj.endTime) {
          this.timeArr.push(obj.endTime)
        }
      }

      if (obj.mainPic) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.mainPic}`
      }

      if (this.addForm.pics) {
        this.pics = this.addForm.pics.split(',')
        this.pics.map(item => {
          this.fileList.push({
            url: `/singleMuseum/attach/getFile?fileId=${item}`
          })
        })
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delEnExhibition({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return false
      }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return false
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.mainPic = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },


    //封面设置
    uploadPicture() {
      if (this.operation == "view") {
        return
      }
      let option = {
        cropWidth: "345", cropHeight: "194", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },


    // 上传团队图片
    beforeUnitPicUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return false
      }

      if (fileType === '.jpg' || fileType === '.png' || fileType === '.jpeg' || fileType === '.bmp' || fileType === '.gif') {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return false
      }
    },

    handleUnitPicSuccess(res, file, fileList) {
      if (res.success) {
        this.$message.success('上传成功')
        this.pics.push(res.result.attId)
      } else {
        let index = 0;
        for (const i in fileList) {
          if (fileList[i] == file) {
            index = i;
            break;
          }
        }
        //移出当前文件对象
        fileList.splice(index, 1);
        this.$message.error(res.message)
      }
    },

    handleUnitPicRemove(file, fileList) {
      this.pics = []
      if (fileList && fileList.length > 0) {
        fileList.map(item => {
          if (item.response && item.response.result) {
            this.pics.push(item.response.result.attId)
          } else {
            // 修改状态
            if (item.url) {
              let arr = item.url.split('=')
              this.pics.push(arr[1])
            }
          }
        })
      }
    },

    onSubmit() {
      const self = this
      let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (!content) {
        this.$message.info('请输入展览简介')
        return
      } else {
        this.addForm.des = content
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = "addEnExhibition"
          if (this.addForm.id) {
            url = "updateEnExhibition"
          }

          if (this.exhibitonType == 1) {
            if (this.timeArr && this.timeArr.length > 0) {
              this.addForm.beginTime = this.timeArr[0]
              this.addForm.endTime = this.timeArr[1]
            }
          }

          if (this.pics && this.pics.length > 0) {
            this.addForm.pics = this.pics.join(',')
          } else {
            this.addForm.pics = ""
          }
          this.$api.applet[url](this.addForm).then(res => {
            this.loadingSave = false
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '展览修改成功' : '展览新增成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            }
          }).catch(err => {
            this.loadingSave = false
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.fileList = []
      this.pics = []
      this.timeArr = []
      this.$refs["form"].clearValidate()
      this.$refs.myCkeditor.initEditor()

    },
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .com-search-box {
    .el-form-item {
      width: 100%;
      display: flex;
      .el-form-item__content{
        flex: 1;
      }
    }
  }
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
      .el-date-editor,
      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      .el-form-item__content {
        .avatar-uploader {
          width: 100%;
          border: 1px dashed #8c939d;
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .el-upload {
            width: 100%;
            height: 150px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .el-icon-plus {
            font-size: 20px;
          }

          .el-upload__text {
            line-height: 1;
          }
        }

        .img-uploader {
          height: 100%;
          line-height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        }
      }
    }
  }
}
</style>